module.exports = __webpack_public_path__ + "img/trade_and_cashback_04.78bd5020.png";